export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Controllo AML"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci un indirizzo e seleziona una blockchain — eseguiremo uno screening rapido."])}
}